import styled from 'styled-components';

export const AssetBarPlaceholder = styled.div`
  width: 100%;
  height: 64px;
  border-radius: 8px;
  background-color: #100418;
  background-image: linear-gradient(to right, #100418 0%, #171328 20%, #100418 40%, #100418 100%);
  background-repeat: no-repeat;
  background-size: 200% 100%;
  display: inline-block;
  animation: assetBarShimmer 0.75s forwards linear infinite;
  overflow: hidden;
  position: relative;

  @keyframes assetBarShimmer {
    0% {
      background-position: 100% 0;
    }
    100% {
      background-position: -100% 0;
    }
  }
`;
